import React from 'react';
import { dataTypes } from '../utils/nodeTemplates';

/**
 * Editor for ProcessInput list
 */
function InputEditor({ inputs, onChange }) {
  const handleAdd = () => {
    const newInput = {
      name: `input_${inputs.length + 1}`,
      type: 'string',
      required: true,
      default: '',
      description: '',
    };
    onChange([...inputs, newInput]);
  };

  const handleRemove = (index) => {
    const newInputs = [...inputs];
    newInputs.splice(index, 1);
    onChange(newInputs);
  };

  const handleUpdate = (index, field, value) => {
    const newInputs = [...inputs];
    newInputs[index] = { ...newInputs[index], [field]: value };
    onChange(newInputs);
  };

  return (
    <div className="io-section">
      <div className="io-section-header">
        <h4>Inputs</h4>
        <button className="btn-small add" onClick={handleAdd}>+ Add</button>
      </div>

      {inputs.length === 0 ? (
        <p className="empty-message">No inputs defined</p>
      ) : (
        <div className="io-list">
          {inputs.map((input, index) => (
            <div key={index} className="io-item">
              <div className="io-item-header">
                <span className="io-item-name">
                  {input.name || `Input ${index + 1}`}
                </span>
                <div className="io-item-actions">
                  <button 
                    className="btn-icon delete" 
                    onClick={() => handleRemove(index)}
                    title="Remove input"
                  >
                    ×
                  </button>
                </div>
              </div>

              <div className="io-item-row">
                <div className="io-item-field">
                  <label>Name</label>
                  <input
                    type="text"
                    value={input.name || ''}
                    onChange={(e) => handleUpdate(index, 'name', e.target.value)}
                    placeholder="input_name"
                  />
                </div>
                <div className="io-item-field">
                  <label>Type</label>
                  <select
                    value={input.type || 'string'}
                    onChange={(e) => handleUpdate(index, 'type', e.target.value)}
                  >
                    {dataTypes.map((dt) => (
                      <option key={dt.value} value={dt.value}>{dt.label}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="io-item-row">
                <div className="io-item-field">
                  <label>Default Value</label>
                  <input
                    type="text"
                    value={input.default || ''}
                    onChange={(e) => handleUpdate(index, 'default', e.target.value)}
                    placeholder="Default value"
                  />
                </div>
                <div className="io-item-field" style={{ maxWidth: '80px' }}>
                  <label>Required</label>
                  <div className="io-item-checkbox">
                    <input
                      type="checkbox"
                      checked={input.required ?? true}
                      onChange={(e) => handleUpdate(index, 'required', e.target.checked)}
                    />
                    <span>Yes</span>
                  </div>
                </div>
              </div>

              <div className="io-item-row">
                <div className="io-item-field">
                  <label>Description</label>
                  <input
                    type="text"
                    value={input.description || ''}
                    onChange={(e) => handleUpdate(index, 'description', e.target.value)}
                    placeholder="Input description"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default InputEditor;
